import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SDCXExternalDomains() {
    return (
        <React.Fragment>
            <p>
                Signiant SDCX Server Software is supported by additional services hosted by Signiant via{' '}
                <strong>signiant.com</strong> and <strong>mediashuttle.com</strong>, and are supported by additional
                Amazon AWS services at <strong>amazonaws.com</strong>.
            </p>
            <p>Access to required domains can be established by opening outbound HTTPS to all IP addresses.</p>
            <p>If outbound HTTPS access is restricted, ensure that the following wildcard domains can be reached:</p>
            <ul>
                <li>
                    <code className="language-text">*.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">*.mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">*.amazonaws.com</code>
                </li>
                <li>
                    <code className="language-text">*.awsglobalaccelerator.com</code>
                </li>
            </ul>
            <p>If your firewall is unable to support wildcard domains, allow access to the following hosts:</p>
            <ul>
                <li>
                    <code className="language-text">updates.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">device-service.services.cloud.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">server-events.services.cloud.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">prod-installer-useast1.services.cloud.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">prod-installer-uswest2.services.cloud.signiant.com</code>
                </li>
                <li>
                    <code className="language-text">mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">mscloud.mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">updates.mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">license.mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">portals.mediashuttle.com</code>
                </li>
                <li>
                    <code className="language-text">a2xy0445m8zinb.iot.us-east-1.amazonaws.com</code>
                </li>
                <li>
                    <code className="language-text">a2xy0445m8zinb.iot.us-west-2.amazonaws.com</code>
                </li>
                <li>
                    <code className="language-text">afe65da3736f118fa.awsglobalaccelerator.com</code>
                </li>
            </ul>
        </React.Fragment>
    );
}

SDCXExternalDomains.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SDCXExternalDomains);
